import { Avatar, Box, Button, Grid, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
// import dummyAvatar from "src/assets/images/default_avatar.svg";
// import banner from "src/assets/images/my-account-banner.jpg";
import { BiChevronRight } from "react-icons/bi";
import Image1 from "src/assets/images/product1.webp"
import Image2 from "src/assets/images/product2.webp"
import Image3 from "src/assets/images/product3.webp"
import Image4 from "src/assets/images/product4.webp"
import Image5 from "src/assets/images/product5.webp"
import Image6 from "src/assets/images/product6.webp"
import ProductHeader from "./components/ProductHeader";
import { LocationOn, LocationOnOutlined, Place, Share } from "@mui/icons-material";
// import ProductCard from "../landing/components/section3/ProductCard";
import ProductFooter from "./components/ProductFooter";
import InfiniteScroll from "react-infinite-scroller";

export const Product = () => {
    const navigate = useNavigate()

    const [product, setProduct] = useState(
        {
            image: Image1,
            name: "Floor drain iron 15*15 20*20",
            price: "$2.00",
            brand: "Percussion wei yu ",
            address: "19282 19312 4F District 2 - International Trade Market",
            brandProducts: [
                {
                    image: Image2,
                },
                {
                    image: Image3,
                },
                {
                    image: Image4,
                }
            ],
            extraImages: [
                {
                    image: Image1,
                },
                {
                    image: Image1,
                },
            ],
            shippingInformation: [
                {
                    title: "Sort",
                    description: "futures"
                },
                {
                    title: "Material",
                    description: "常规"
                },
                {
                    title: "Packing Qty",
                    description: "100PCS/CTN"
                }
            ],
            relatedThisSuppplierProducts: [
                {
                    image: Image1,
                    name: "Floor drain iron 15*15 20*20",
                    price: "$2.00"
                },
                {
                    image: Image2,
                    name: "PP quick - connect double - drive ball valve",
                    price: "$1.00"
                },
            ],
            recommendProducts: [
                {
                    image: Image3,
                    name: "Yiwu Good Diyi Color vacuum cup #/F3-026",
                    price: "$5.00"
                },
                {
                    image: Image4,
                    name: "Yiwu Selection fashionable language bounce thermos cup large #/F3-026",
                    price: "$2.50"
                },
                {
                    image: Image5,
                    name: "Yiwu Selection Mini Bounce thermos Cup #/F3-026",
                    price: "$2.34"
                },
                {
                    image: Image6,
                    name: "Yiwu Selection Planet Cat Humidifier (pink)/17529",
                    price: "$6.93"
                },
            ],

        },
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const onBack = () => {
        navigate(-1);
    }

    const onMore = () => {
    }

    const onClickProduct = () => {
    }

    const onTabChange = (index) => {
        console.log(index);
        let section;
        if (index === 0) {
            section = document.querySelector('#overview');
        } else if (index === 1) {
            section = document.querySelector('#details');
        } else if (index === 2) {
            section = document.querySelector('#recommend');
        }

        if (section !== null) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    return (
        <>
            <div className="mobile-view">
                <Box className="product-page" id="overview">
                    <ProductHeader
                        onBack={onBack}
                        onMore={onMore}
                        onTabChange={onTabChange}
                    />

                    <Box sx={{
                        width: "100%",
                        position: "relative"
                    }}>
                        <Avatar
                            variant="square"
                            src={product?.image}
                            sx={{
                                width: "100%",
                                height: "auto"
                            }}
                        />
                        <Box className="share-btn">
                            <Share className="share-icon" />
                        </Box>
                    </Box>

                    <Box mb={3} className="product-box">
                        <Box mb={3}>
                            <Typography
                                variant="paragraph"
                                className="product-title"
                            >
                                {product?.name}
                            </Typography>
                        </Box>

                        <Grid mb={2} container columns={{ xs: 12, lg: 12 }} spacing={{ xs: 2, lg: 2 }}>
                            <Grid item xs={4} lg={4}>
                                <Box className="product-price-box">
                                    <Typography
                                        variant="paragraph"
                                        className="product-price"
                                    >
                                        {product?.price}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>

                    </Box>

                    {/* Brand */}
                    <Box mb={3} className="product-box product-shop">
                        <Box mb={2} className="d-flex justify-content-between">
                            <Box>
                                <Typography
                                    variant="paragraph"
                                    className="product-brand"
                                >
                                    {product?.brand}
                                </Typography>
                            </Box>

                            <Box>
                                <Button
                                    disableElevation
                                    variant="outlined"
                                    onClick={(event) => {

                                    }}
                                    className="visit-store-button"
                                    sx={{
                                        borderRadius: "25px",
                                    }}
                                >
                                    Visit Store
                                </Button>
                            </Box>
                        </Box>

                        <Box className="product-address-box d-flex">
                            <LocationOnOutlined className="address-icon" />
                            <Typography
                                variant="paragraph"
                                className="product-address"
                            >

                                {product?.address}
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Grid container columns={{ xs: 12, lg: 12 }} spacing={{ xs: 2, lg: 2 }}>
                                {product.brandProducts?.map((item, index) => (
                                    <Grid key={item.id} item xs={4} lg={4}>
                                        <Box onClick={() => {
                                            onClickProduct(item);
                                        }}>
                                            <Avatar
                                                variant="square"
                                                src={item?.image}
                                                className="brand-product-div"
                                            />
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>

                    {/* Extra Images */}
                    <Box mb={3} className="product-box" id="details">
                        {product.extraImages?.map((item, index) => (
                            <Box mb={2} key={item.id}>
                                <Avatar
                                    variant="square"
                                    src={item?.image}
                                    className="extra-image-div"
                                />
                            </Box>
                        ))}
                    </Box>

                    {/* Shipping Information */}
                    <Box mb={3} className="product-box">
                        <Box mb={2} pl={1}>
                            <Typography
                                variant="paragraph"
                                className="product-shipping-title"
                            >
                                Shipping Information
                            </Typography>
                        </Box>

                        {product.shippingInformation?.map((item, index) => (
                            <Box p={2} key={item.id} className="product-attr-item">
                                <Grid container columns={{ xs: 12, lg: 12 }} spacing={{ xs: 2, lg: 2 }}>
                                    <Grid item xs={6} lg={6}>
                                        <Typography
                                            variant="paragraph"
                                            className="product-shipping-item-title"
                                        >
                                            {item.title}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} lg={6}>
                                        <Typography
                                            variant="paragraph"
                                            className="product-shipping-item-description"
                                        >
                                            {item.description}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        ))}
                    </Box>

                    {/* Related Products from this Supplier */}
                    <Box mb={2} pl={5}>
                        <Typography
                            variant="paragraph"
                            className="product-related-products-title"
                        >
                            Related Products from this Supplier
                        </Typography>
                    </Box>

                    <Box mb={3} p={2}>
                        <Grid container columns={{ xs: 12, lg: 12 }} spacing={{ xs: 2, lg: 2 }}>
                            {product.relatedThisSuppplierProducts?.map((item, index) => (
                                <Grid key={item.id} item xs={6} lg={6} >
                                    {/* <ProductCard product={item} /> */}
                                </Grid>
                            ))}
                        </Grid>
                    </Box>

                    {/* Recommended From Other Suppliers */}
                    <Box mb={2} pl={5} id="recommend">
                        <Typography
                            variant="paragraph"
                            className="product-recommended-products-title"
                        >
                            Recommended From Other Suppliers
                        </Typography>
                    </Box>

                    <Box p={2}>
                        {/* <InfiniteScroll
                            pageStart={0}
                            loadMore={fetchMoreJob}
                            hasMore={isloadMore}
                            loader={<div
                                className="loader"
                                key={0}
                                style={{
                                    textAlign: "center",
                                    paddingBottom: "10px",
                                }}
                            >
                                Loading ...
                            </div>}
                        > */}
                            <Grid container columns={{ xs: 12, lg: 12 }} spacing={{ xs: 2, lg: 2 }}>
                                {product.recommendProducts?.map((item, index) => (
                                    <Grid key={item.id} item xs={6} lg={6} >
                                        {/* <ProductCard product={item} /> */}
                                    </Grid>
                                ))}
                            </Grid>
                        {/* </InfiniteScroll> */}
                    </Box>

                    <Box pb={2} />

                    <ProductFooter />
                </Box>
            </div >
        </>
    )
}

export default Product
